import React from 'react';
import { useMediaQuery } from 'react-responsive';
import OnlineStoreContent from './OnlineStoreContent';

const Mobile = ({ children }) => {
  const isMobile = useMediaQuery({ maxWidth: 767 });
  return isMobile ? children : null;
};

const MobileResponsive = ({ history }) => (
  <Mobile>
    <OnlineStoreContent history={history} />
  </Mobile>
);

export default MobileResponsive;
